export const environment = {
  appRoot: '',
  production: true,
  googleApiKey: '?client=gme-helsanaversicherungen'
};
